import FlexContainer, { FlexContainerProps } from './FlexContainer';

export default FlexContainer;

export type { FlexContainerProps }